// テレコムクレジットのボタン。
//
// サーバから「送る中身」を受け取り、テレコムの決済画面へ **POST で遷移** する
// （仕様書の推奨。GET だと値が URL に出る）。金額・照合の印はサーバが決める。
//
// 支払えたかどうかは、テレコムがサーバへ送る結果で決まる。戻ってきた直後は
// まだ反映前のことがある（画面側で「確認中」と出す）。
//
// `kind="bank"` は銀行振込（口座発行型・即時振込型）。振込先はテレコムの画面・メールで
// 案内され、入金が確認できたらテレコムからサーバへ届く。
import { useState } from "react";
import { api } from "../api";

interface CheckoutResp {
  action: string;
  fields: Record<string, string>;
}

/** テレコムの決済画面だけに送る（それ以外の宛先には送らない） */
const ALLOWED_ACTION = /^https:\/\/secure\.telecomcredit\.co\.jp\//;

const LABEL = {
  card: "クレジットカードで支払う（テレコムクレジット）",
  bank: "銀行振込で支払う（テレコムクレジット）",
} as const;

export function TelecomPayButton({
  applicationId,
  kind = "card",
}: {
  applicationId: string;
  kind?: "card" | "bank";
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const go = async () => {
    setBusy(true);
    setErr(null);
    try {
      const r = await api.get<CheckoutResp>(
        `/payments/telecom/checkout/${applicationId}${kind === "bank" ? "?kind=bank" : ""}`,
      );
      if (!ALLOWED_ACTION.test(r.action)) throw new Error("決済画面の宛先が想定外です");
      const form = document.createElement("form");
      form.method = "POST";
      form.action = r.action;
      for (const [name, value] of Object.entries(r.fields)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
      // 画面が切り替わるまでボタンは押せないままにする（二重送信を防ぐ）
    } catch (e) {
      setErr((e as Error).message);
      setBusy(false);
    }
  };

  return (
    <div className="space-y-1">
      <button
        type="button"
        className={kind === "bank" ? "btn-outline" : "btn-primary"}
        disabled={busy}
        onClick={go}
      >
        {busy ? "決済画面へ移動中…" : LABEL[kind]}
      </button>
      {err && <p className="text-sm text-red-700">{err}</p>}
    </div>
  );
}
